import { render } from "./SettingsModal.vue?vue&type=template&id=3c5686c7"
import script from "./SettingsModal.vue?vue&type=script&lang=js"
export * from "./SettingsModal.vue?vue&type=script&lang=js"
script.render = render

export default script